'use strict';

(function() {
  window.atex = window.atex || {};

  atex.upgrade = {
    dbUpgradeCallback: function(event) {
      var database = event.target.result;
      var oldVersion = event.oldVersion || 0;

      // THIS IS WEIRD. But it's because of iOS 8 (possibly Safari 8 as well) reports
      // this as a huge number instead of 0.
      if (oldVersion > 100000000) {
        oldVersion = 0;
      }

      for (var i = oldVersion + 1; i <= event.newVersion; i++) {
        console.log('INFO: Upgrading database to version ' + i + '.');
        upgrades[i](database);
      }
    }
  };

  var upgrades = [];

  upgrades[1] = function(database) {
    database.createObjectStore('content', { keyPath: 'meta.id' });
    database.createObjectStore('templates', { keyPath: 'id' });
    database.createObjectStore('taxonomies', { keyPath: 'id' });
    database.createObjectStore('userdata', { keyPath: 'id' });
  };

  upgrades[2] = function(database) {
    database.deleteObjectStore('userdata');
    database.createObjectStore('userdata', { keyPath: 'contentData.id' });
  };

  upgrades[3] = function(database) {
    database.deleteObjectStore('userdata');
    database.deleteObjectStore('taxonomies');

    database.createObjectStore('userdata', { keyPath: 'id' });
  };
})();
